import React, { useState, useEffect, useRef } from 'react'
import { SplitSquareHorizontal, ChevronRight } from 'lucide-react'
import { lotesService } from '../../services/lotesService'

const statusColor = {
  NOVO:     'text-blue-600 bg-blue-50',
  FATURADO: 'text-green-600 bg-green-50',
  DEFESA:   'text-yellow-600 bg-yellow-50',
}

const RefugoBadge = ({ organizadorId, loteId, qtdTotalRefugada }) => {
  const [open, setOpen] = useState(false)
  const [filhos, setFilhos] = useState(null)
  const [loading, setLoading] = useState(false)
  const ref = useRef(null)

  const carregar = async () => {
    if (filhos !== null) return
    setLoading(true)
    try {
      const data = await lotesService.listarLotesRefugo(organizadorId, loteId)
      setFilhos(data)
    } catch {
      setFilhos([])
    } finally {
      setLoading(false)
    }
  }

  const handleToggle = () => {
    if (!open) carregar()
    setOpen(v => !v)
  }

  // Fecha ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  return (
    <div ref={ref} className="relative inline-flex">
      <button
        type="button"
        onClick={handleToggle}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold
          rounded-lg bg-orange-100 text-orange-700 hover:bg-orange-200 border border-orange-200
          active:scale-95 transition-all"
        title="Este lote teve animais refugados"
      >
        <SplitSquareHorizontal size={13} />
        Refugado · {qtdTotalRefugada} {qtdTotalRefugada === 1 ? 'animal' : 'animais'}
        <ChevronRight size={12} className={`transition-transform ${open ? 'rotate-90' : ''}`} />
      </button>

      {open && (
        <div className="absolute top-full left-0 mt-1.5 z-[9999] bg-white border border-gray-200
          rounded-xl shadow-xl min-w-[220px] overflow-hidden">
          <div className="px-3 py-2 border-b border-gray-100 bg-gray-50">
            <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide">
              Lotes gerados por refugo
            </p>
          </div>

          {loading && (
            <div className="px-4 py-3 flex items-center gap-2 text-xs text-gray-500">
              <svg className="w-3.5 h-3.5 animate-spin" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
              </svg>
              Carregando…
            </div>
          )}

          {!loading && filhos?.length === 0 && (
            <p className="px-4 py-3 text-xs text-gray-400">Nenhum lote encontrado</p>
          )}

          {!loading && filhos?.length > 0 && (
            <div className="py-1">
              {filhos.map(f => (
                <div key={f.id} className="flex items-center justify-between px-3 py-2 hover:bg-gray-50">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-gray-800">{f.numero_lote}</span>
                    <span className="text-xs text-gray-500">{f.qtd} {f.qtd === 1 ? 'animal' : 'animais'}</span>
                  </div>
                  <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${statusColor[f.status] || 'text-gray-600 bg-gray-100'}`}>
                    {f.status}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default RefugoBadge
